<div [ngClass]="getClassNames()">
  <div class="ub-form__readable__label">
    {{ label }}
  </div>
  <div class="ub-form__readable__value" *ngIf="value">
    {{ value }}
  </div>
  <div class="ub-form__readable__rich-text">
    <ng-content select="[richText]"></ng-content>
  </div>
</div>
